import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ p, index = 0 }) {
  const price = p.is_free ? "FREE" : `£${Number(p.price).toFixed(2)}`;
  return (
    <motion.div
      data-testid={`product-card-${p.slug}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay: (index % 6) * 0.06, ease: [0.19, 1, 0.22, 1] }}
      className="pc-card group relative border border-white/10 bg-[color:var(--bg-surface)] overflow-hidden"
    >
      <Link to={`/product/${p.slug}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden">
          <img src={p.image} alt={p.name} className="pc-img w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none" />
          <div className="absolute top-3 left-3 tag-chip">[ {p.category.replaceAll("-", " ").toUpperCase()} ]</div>
          {p.category === "businesses" && (
            <div className="absolute top-3 right-3 tag-chip border-[color:var(--accent-red)] text-[color:var(--accent-red)]">
              SUBSCRIPTION · MONTHLY
            </div>
          )}
          {p.stock != null && p.category !== "businesses" && (
            <div className="absolute top-3 right-3 tag-chip border-[color:var(--accent-red)] text-[color:var(--accent-red)]">
              STOCK {p.stock}
            </div>
          )}
          <div className="absolute bottom-3 right-3 h-10 w-10 border border-white/40 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
            <ArrowUpRight className="w-4 h-4 text-white" />
          </div>
        </div>
        <div className="p-5 flex items-end justify-between gap-4">
          <div>
            <div className="font-display text-xl text-white leading-tight uppercase tracking-tight">{p.name}</div>
            {p.tagline && <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-1">{p.tagline}</div>}
          </div>
          <div className="font-mono text-white text-sm">{price}</div>
        </div>
      </Link>
    </motion.div>
  );
}
